import { Component, OnInit } from '@angular/core';
import { EMailService } from '../../../services/email.service';
import { EDeliveryService } from '../../../services/edelivery.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
// import { debounceTime } from 'rxjs/operators';
import { Email } from '../../../models/e-mail.model';
import { Emailresponse } from '../../../models/emailresponse.model';
import { Inject } from '@angular/core';
import { LogService } from '@pershing/pershing-core';
import { EdeliveryLabels } from '../../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
  selector: 'deleteEmail',
  templateUrl: './deleteEmail.component.html',
  styleUrls: ['./deleteEmail.component.css']
})
export class DeleteEmailComponent implements OnInit {
  emailResponse: Observable<Emailresponse>;
  errorMessage: String;
  emailToDelete: Email;
  emails: Email[];
  log: LogService;
  deleteEmailSubscription: Subscription;

  deleteEmailTitle = EdeliveryLabels.DELETE_EMAIL_ADDRESS;
  deleteEmailMessage: any = EdeliveryLabels.DELETE_EMAIL_MESSAGE;
  yesLabel = EdeliveryLabels.YES_LABEL;
  noLabel = EdeliveryLabels.NO_LABEL;
  cancelLabel = EdeliveryLabels.CANCEL;

  constructor(private emailService: EMailService, private edeliveryService: EDeliveryService,
              public dialogRef: MatDialogRef<DeleteEmailComponent>, @Inject(MAT_DIALOG_DATA) public data: any, log: LogService,
              private translate: PershingTranslationService) {
    this.log = log;
    this.emailToDelete = data.email;
    if (this.translate) {
      this.translate.addTranslationFolder('@pershing/edc-edelivery', 'node_modules/@pershing/edc-edelivery/lib');
    }
  }
  ngOnInit() {
    this.log.info(this.emailToDelete);
  }

  ngOnDestroy() {
    if (this.deleteEmailSubscription) {
        this.deleteEmailSubscription.unsubscribe();
    }
  }

  deleteEmail(): void {
    console.log('calling delete email');
    this.emailService.deleteEmail(this.emailToDelete);
    this.edeliveryService.triggerLoadingIcon(true);
    this.emailService.updateEmailTriggered = true;
    this.close();
    // this.emailResponse = this.emailService.emailresponse$;
    // this.deleteEmailSubscription = this.emailResponse.pipe(debounceTime(800)).subscribe(response => { // Subscribe to the Observable which gets updated from the email.service.ts
    //   if (response) {
    //     this.edeliveryService.retrievePreferences();
    //     // this.edeliveryService.triggerLoadingIcon(true);
    //     this.dialogRef.close();
    //   }
    // });
  }
  close() {
    this.dialogRef.close();
  }

}
